import React, { useCallback, useEffect, useRef, useState } from "react";
import Header from "../components/Header";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
  Typography,
} from "@material-ui/core";
import PatientStatus from "../components/PatientStatus";
import { apiAxios } from "../Util/ApiAxios";
import { BiXCircle } from "react-icons/bi";
import { Pagination } from "@material-ui/lab";

const RequestActionTakenList = () => {
  const classes = useStyles();
  const [actionTakenList, setActionTakenList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const currentPageRef = useRef(1);
  const [message, setMessage] = useState("");
  const [isReasonModal, setReaonModal] = useState(false);
  const [reasonList, setReasonList] = useState([]);
  const getActionTakenList = useCallback(
    async ({
      table_config_rows_per_page = "20",
      table_config_page_no = "1",
    } = {}) => {
      setCurrentPage(parseInt(table_config_page_no));

      setActionTakenList([]);
      setMessage("Loading...");

      const userData = {
        table_config_rows_per_page: table_config_rows_per_page,
        table_config_page_no: table_config_page_no,
        status_filter: [9, 10, 11],
      };

      apiAxios
        .post("/user/request-list", userData, {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("dhct_Token"),
          },
        })
        .then((response) => {
          console.log("response --> ", response);
          if (response.data.statusCode == 200) {
            setActionTakenList(response.data.body);
            setMessage(response.data.body.length === 0 ? "No Data Found" : "");
            const total_Pages = Math.ceil(
              response.data.total_rows_count / response.data.rows_per_page
            );
            setTotalPages(total_Pages);
          } else if (response.data.statusCode == 502) {
            setMessage("No Data Found");
          } else {
            setMessage(response.data.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    []
  );
  useEffect(() => {
    getActionTakenList({
      table_config_page_no: currentPageRef.current.toString(),
    });
  }, [getActionTakenList]);
  const openReasonModal = (selected) => {
    setReasonList(selected);
    setReaonModal(true);
  };
  const closeReasonModal = (e) => {
    e?.stopPropagation();
    setReaonModal(false);
  };

  return (
    <div>
      <Header />
      <Box className={classes.pagecontent}>
        <Box className={classes.leftcol}>
          <Box className={classes.leftnav} style={{ marginTop: "40px" }}>
            {localStorage.getItem("dhct_JWT") ? <PatientStatus /> : <></>}
          </Box>
        </Box>
        <Box className={classes.Rightcol}>
          <Box>
            <h3 className={classes.topheading}>Request Action Taken List</h3>
          </Box>
          <Box className={classes.PatientListTable}>
            <Box className={classes.throw}>
              <Box className={classes.program}>Appointment with</Box>
              <Box className={classes.provider}>Patient Name</Box>
              <Box className={classes.date}>Date</Box>
              <Box className={classes.time}>Slot Time</Box>
              <Box className={classes.hrpmID}>HRPM ID</Box>
              <Box className={classes.phone}>Current Status</Box>
              <Box className={classes.reason}>Reson</Box>
            </Box>
            {actionTakenList.length > 0 ? (
              <>
                {actionTakenList.map((each) => (
                  <Box key={each.appointment_number} className={classes.tdrow}>
                    <Box className={classes.program}>{each.doctor_name}</Box>
                    <Box className={classes.provider}>{each.patient_name}</Box>
                    <Box className={classes.date}>{each.appointment_date}</Box>
                    <Box className={classes.time}>
                      {`${
                        each.start_time
                          ? each.start_time.split(":").slice(0, 2).join(":")
                          : ""
                      }-${
                        each.end_time
                          ? each.end_time.split(":").slice(0, 2).join(":")
                          : ""
                      }`}
                    </Box>
                    <Box className={classes.hrpmID}>{each.hrpm_id}</Box>

                    <Box className={classes.phone}>
                      {each.current_status === 9
                        ? "Approved"
                        : each.current_status === 10
                        ? "Rescheduled"
                        : each.current_status === 11
                        ? "Rejected"
                        : each.current_status === 12
                        ? "Acknowledged"
                        : "Request Raised"}
                    </Box>
                    <Box
                      className={classes.reason}
                      onClick={() => openReasonModal(each)}
                    >
                      <b style={{ color: "#88b3eb" }}>View</b>
                    </Box>
                  </Box>
                ))}
              </>
            ) : (
              <Box style={{ marginTop: "30px", textAlign: "center" }}>
                {message ? message : "No Appointments Found"}
              </Box>
            )}
          </Box>
          {/* Reason Modal */}
          <Dialog
            onClose={closeReasonModal}
            aria-labelledby="customized-dialog-title"
            open={isReasonModal}
          >
            <DialogContent className={classes.ccmmodal}>
              <Typography
                variant="h3"
                style={{
                  fontSize: 18,
                  fontFamily: "poppins",
                  fontWeight: "600",
                  marginRight: "60px",
                }}
              >
                Reason for Appointment
              </Typography>
              <Box className={classes.btncol}>
                <Button
                  onClick={closeReasonModal}
                  className={classes.Modalclose}
                >
                  <BiXCircle className={classes.closeicon} />
                </Button>
              </Box>
              <DialogContentText id="alert-dialog-slide-description">
                {reasonList ? (
                  <Typography
                    style={{
                      fontSize: 16,
                      fontFamily: "poppins",
                      marginTop: "10px",
                    }}
                  >
                    {reasonList.reason}
                  </Typography>
                ) : null}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                size="large"
                className={classes.Deletebtn}
                onClick={closeReasonModal}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "right",
              justifyContent: "right",
            }}
          >
            <Pagination
              count={totalPages}
              color="primary"
              page={currentPage}
              onChange={(event, pageNumber) => {
                setCurrentPage(pageNumber);
                getActionTakenList({
                  table_config_page_no: pageNumber.toString(),
                });
              }}
            />
          </div>
        </Box>
      </Box>
    </div>
  );
};

export default RequestActionTakenList;
const useStyles = makeStyles((theme) => ({
  pagecontent: {
    width: "100%",
    overflow: "hidden",
    display: "flex",
    "& a": {
      textDecoration: "none",
    },
  },
  Rightcol: {
    width: "75%",
    padding: "20px 2%",
    borderLeft: "1px #F6F6F6 solid",
    "@media only screen and (max-width: 820px)": {
      width: "96%",
      padding: "0 2%",
      marginTop: 30,
    },
    "@media only screen and (max-width: 768px)": {
      width: "96%",
      padding: "0 2%",
      marginTop: 30,
    },
    "& .MuiAccordionSummary-root": {
      borderBottom: "1px #5f80a9 solid",
      height: "40px",
      color: "#bfc4cb",
      padding: "0px",
      fontFamily: "Poppins",
    },
    "& .MuiAccordion-root:before": {
      display: "none",
    },
    "& .MuiTab-root": {
      minWidth: "33%",
    },
    "& .MuiTab-root:nth-child(6)": {
      minWidth: "30%",
    },
    "& .MuiTab-root:nth-child(7)": {
      minWidth: "30%",
    },
  },

  leftcol: {
    width: "15%",
    padding: "20px 3%",
    minHeight: "800px",
    background: "linear-gradient(-45deg, #114ebd, #0f3d6e)",
    position: "relative",
    "@media only screen and (max-width: 820px)": {
      position: "absolute",
      background: "none",
      width: "96%",
      padding: "30px 2%",
    },
    "@media only screen and (max-width: 768px)": {
      position: "absolute",
      background: "none",
      width: "96%",
      padding: "30px 2%",
    },
    "& ul": {
      listStyle: "none",
      margin: "0px",
      padding: "0px",
      "& li": {
        color: "#1C295D",
        fontSize: "12px",
        fontWeight: "500",
      },
      "& li button": {
        background: "#f1f1f1",
        width: "150px",
        height: "55px",
        margin: "8px 0",
        textAlign: "center",
        color: "#0f3d6e",
        borderRadius: "10px",
        fontSize: "18px",
        "&:hover": {
          background: "#0f3d6e",
        },
      },
    },
  },
  leftnav: {
    position: "absolute",
    top: "15px",
    bottom: "15px",
    left: "40px",
    right: "40px",
    "@media only screen and (max-width: 1200px)": {
      left: "20px",
      right: "20px",
    },
  },
  topheading: {
    fontSize: "18px",
    color: "#000",
    fontWeight: "500",
    alignSelf: "flex-start",
  },
  PatientListTable: {
    width: "100%",
    "@media only screen and (min-device-width: 768px) and (max-device-width: 1200px)":
      {
        overflowX: "auto",
      },
  },
  throw: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "2px #E3E5E5 solid",
    fontSize: "14px",
    color: "#fff",
    paddingBottom: "5px",
    background: "linear-gradient(to left, #114ebd, #0f3d6e)",
    padding: 6,
    "@media only screen and (min-device-width: 768px) and (max-device-width: 1200px)":
      {
        width: 1366,
      },
  },
  tdrow: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px #E3E5E5 solid",
    fontSize: "14px",
    padding: "10px 0",
    "@media only screen and (min-device-width: 768px) and (max-device-width: 1200px)":
      {
        width: 1366,
      },
  },
  providerbtn: {
    display: "flex",
    cursor: "pointer",
    "& span": {
      display: "flex",
      flexDirection: "column",
      width: "20px",
      marginRight: "10px",
      "& button": {
        background: "none",
        border: "none",
        height: "10px",
        cursor: "pointer",
      },
    },
  },
  provider: {
    width: "20%",
    textAlign: "canter",
  },
  time: {
    width: "15%",
    textAlign: "left",
  },
  phone: {
    width: "15%",
    textAlign: "center",
    wordWrap: "break-word",
    overflow: "auto",
  },
  hrpm: {
    width: "10%",
    textAlign: "center",
    wordWrap: "break-word",
    overflow: "auto",
  },
  program: {
    width: "15%",
    textAlign: "left",
    cursor: "pointer",
  },
  date: {
    width: "15%",
    textAlign: "center",
  },
  reason: {
    width: "10%",
    textAlign: "center",
    cursor: "pointer",
  },

  ccmmodal: {
    borderRadius: "10px",
    padding: "20px",
  },
  Modalclose: {
    width: 45,
    height: 45,
    minWidth: 45,
    borderRadius: 50,
    position: "absolute",
    right: 12,
    top: 10,
  },
  closeicon: {
    fontSize: "25px",
    color: "#7087A7",
  },
  Deletebtn: {
    background: "#fff",
    border: "1px #f12626 solid",
    width: "60px",
    height: "30px",
    float: "right",
    color: "#f12626",
    textTransform: "capitalize",
    borderRadius: "10px",
    fontWeight: "600",
    marginBottom: "10px",
    marginRight: "10px",
    "&:hover": {
      background: "#f12626",
      color: "#fff",
    },
  },
}));
